import { RoutesPaths } from "../constants/user-routes"

export const ADMIN_TWO_FACTOR_VERIFICATION_ROUTE = "/admin/2fa-verification"
export const ADMIN_TWO_FACTOR_SETUP_ROUTE = "/admin/2fa-setup"
export const ADMIN_ACCEPT_INVITE_ROUTE_PREFIX = "/admin-invite/"
export const PUBLIC_ADMIN_TWO_FACTOR_ROUTES = [
  ADMIN_TWO_FACTOR_VERIFICATION_ROUTE,
  ADMIN_TWO_FACTOR_SETUP_ROUTE
]

export const isPublicAdminRoute = (pathname = "") =>
  PUBLIC_ADMIN_TWO_FACTOR_ROUTES.includes(pathname) ||
  pathname.startsWith(`${ADMIN_TWO_FACTOR_VERIFICATION_ROUTE}/`) ||
  pathname.startsWith(`${ADMIN_TWO_FACTOR_SETUP_ROUTE}/`) ||
  pathname.startsWith(ADMIN_ACCEPT_INVITE_ROUTE_PREFIX)

export const getAdminTwoFactorRoute = (is2FAConfigured) =>
  is2FAConfigured ? ADMIN_TWO_FACTOR_VERIFICATION_ROUTE : ADMIN_TWO_FACTOR_SETUP_ROUTE

export const getAdminTwoFactorSetupRoute = (token = "") =>
  token
    ? `${ADMIN_TWO_FACTOR_SETUP_ROUTE}/${encodeURIComponent(token)}`
    : ADMIN_TWO_FACTOR_SETUP_ROUTE

export const getAdminTwoFactorVerificationRoute = (token = "") =>
  token
    ? `${ADMIN_TWO_FACTOR_VERIFICATION_ROUTE}/${encodeURIComponent(token)}`
    : ADMIN_TWO_FACTOR_VERIFICATION_ROUTE

export const getAdminPostLoginRoute = () => RoutesPaths.alerts.all
